import { render, staticRenderFns } from "./product.vue?vue&type=template&id=33f2ef49"
import script from "./product.ts?vue&type=script&lang=js&external"
export * from "./product.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports